import React from "react";
import $ from "jquery";
import SimpleImageSlider from "react-simple-image-slider";
import FeaturedImage from "../../src/assest/images/Room for rent 3.png";
import { useState, useEffect } from "react";
   
import appURLs from "../appURL";
import { toast } from "react-toastify";
import SocialMediaLink from "./socialMediaLink/socialMediaLink";
import { useLocation, useNavigate } from "react-router-dom";

export default function Jobcard(props) {
  const { _id, myFavourite } = props;
  const navigate =useNavigate()
  const appURL = appURLs();
  const [isFavourite, setIsFavourite] = useState(false);
  const tokenExist = localStorage.getItem("token");
  const [isShareOpen, setIsShareOpen] = useState(false);
  const [url,seturl]=useState()

  const handleHeartIconClick = (event) => {
    event.stopPropagation();
    setIsFavourite(!isFavourite);

    const adsInfo = localStorage.getItem("adsInfo");
    const adsData = JSON.parse(adsInfo);

    const requestBody = {
      adId: _id,
      ads_type: "64e48fa9f9eeb14b6e2135be",
      isfavorite: !isFavourite,
    };

    const token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    fetch(`${appURL}/posts/ads/create-favorite`, {
      method: "POST",
      body: JSON.stringify(requestBody),
      headers: headers,
    })
      .then((response) => {
        if (response.ok) {
          if (!isFavourite) {
            toast.success("Item added to Favourite");
          } else {
            toast.error("Item removed from Favorite");
          }
        } else {
          console.error("Error sending the report.");
        }
      })
      .catch((error) => {
        console.error("Error sending the report:", error);
      });
  };

  const shareSocialMediaLink =(event,id,data)=>{
    event.stopPropagation();
    const baseUrl = window.location.origin;
    let url =`${baseUrl}/jobDetails/${id}`
    seturl(url)
    setIsShareOpen(!isShareOpen);
  }


  const titlebtn = (id) => {
     navigate(`/jobDetails/${id}`)
  };

  useEffect(() => {
    setIsFavourite(myFavourite);
  }, [props]);

  return (
    <div className="card-image">
      <div className="card" onClick={()=>{titlebtn(props._id)}}>
        <div className="cardimage">
          {props.imageSrc.length > 0 ? (
            <SimpleImageSlider
              width={"100%"}
              height={200}
              images={props.imageSrc}
              showNavs={props.imageSrc.length > 1 ? true : false}
              showBullets={props.imageSrc.length > 1 ? true : false}
              
            />
          ) : (
            <img
              width={"100%"}
              height={200}
              src={FeaturedImage}
              alt="Featured"
            />
          )}

          <div className="fav-icon">
            <div className=" location">
              {props.featured ? (
                <svg
                  width="91"
                  height="26"
                  viewBox="0 0 91 26"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="0.935547"
                    width="91"
                    height="25"
                    rx="4"
                    fill="#F07639"
                  />
                  <path
                    d="M14.7585 17.9355V9.20827H20.5369V10.7296H16.6037V12.8091H20.1534V14.3304H16.6037V17.9355H14.7585ZM21.7781 17.9355V9.20827H27.6587V10.7296H23.6232V12.8091H27.3562V14.3304H23.6232V16.4142H27.6758V17.9355H21.7781ZM30.63 17.9355H28.6527L31.6655 9.20827H34.0433L37.0518 17.9355H35.0746L32.8885 11.2026H32.8203L30.63 17.9355ZM30.5064 14.5051H35.1768V15.9455H30.5064V14.5051ZM36.7035 10.7296V9.20827H43.8711V10.7296H41.1992V17.9355H39.3754V10.7296H36.7035ZM50.4421 9.20827H52.2873V14.8759C52.2873 15.5123 52.1353 16.0691 51.8313 16.5463C51.5302 17.0236 51.1083 17.3958 50.5657 17.6628C50.0231 17.927 49.391 18.0591 48.6694 18.0591C47.945 18.0591 47.3114 17.927 46.7688 17.6628C46.2262 17.3958 45.8043 17.0236 45.5032 16.5463C45.2021 16.0691 45.0515 15.5123 45.0515 14.8759V9.20827H46.8967V14.7182C46.8967 15.0506 46.9691 15.3461 47.114 15.6046C47.2617 15.8631 47.4691 16.0662 47.7362 16.214C48.0032 16.3617 48.3143 16.4355 48.6694 16.4355C49.0273 16.4355 49.3384 16.3617 49.6026 16.214C49.8697 16.0662 50.0756 15.8631 50.2205 15.6046C50.3683 15.3461 50.4421 15.0506 50.4421 14.7182V9.20827ZM53.8054 17.9355V9.20827H57.2486C57.9077 9.20827 58.4702 9.32617 58.9361 9.56197C59.4048 9.79492 59.7614 10.1259 60.0057 10.5549C60.2528 10.981 60.3764 11.4824 60.3764 12.0591C60.3764 12.6387 60.2514 13.1373 60.0014 13.5549C59.7514 13.9696 59.3892 14.2878 58.9148 14.5094C58.4432 14.731 57.8722 14.8418 57.2017 14.8418H54.8963V13.3588H56.9034C57.2557 13.3588 57.5483 13.3105 57.7812 13.214C58.0142 13.1174 58.1875 12.9725 58.3011 12.7793C58.4176 12.5861 58.4759 12.3461 58.4759 12.0591C58.4759 11.7694 58.4176 11.525 58.3011 11.3262C58.1875 11.1273 58.0128 10.9767 57.777 10.8745C57.544 10.7694 57.25 10.7168 56.8949 10.7168H55.6506V17.9355H53.8054ZM58.5185 13.964L60.6875 17.9355H58.6506L56.5284 13.964H58.5185ZM61.6804 17.9355V9.20827H67.5611V10.7296H63.5256V12.8091H67.2585V14.3304H63.5256V16.4142H67.5781V17.9355H61.6804ZM72.1218 17.9355H69.0281V9.20827H72.1474C73.0252 9.20827 73.7809 9.38299 74.4144 9.73242C75.0479 10.079 75.5352 10.5776 75.8761 11.2282C76.2198 11.8787 76.3917 12.6571 76.3917 13.5634C76.3917 14.4725 76.2198 15.2537 75.8761 15.9071C75.5352 16.5605 75.0451 17.062 74.4059 17.4114C73.7695 17.7608 73.0082 17.9355 72.1218 17.9355ZM70.8732 16.3546H72.0451C72.5906 16.3546 73.0494 16.258 73.4215 16.0648C73.7965 15.8688 74.0778 15.5662 74.2653 15.1571C74.4556 14.7452 74.5508 14.214 74.5508 13.5634C74.5508 12.9185 74.4556 12.3915 74.2653 11.9824C74.0778 11.5733 73.7979 11.2722 73.4258 11.079C73.0536 10.8858 72.5948 10.7892 72.0494 10.7892H70.8732V16.3546Z"
                    fill="#ffffff"
                  />
                </svg>
              ) : (
                ""
              )}
            </div>

            {tokenExist && (
              <div className="heart_hover">
                {!isFavourite ? (
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={handleHeartIconClick}
                  >
                    <g clipPath="url(#clip0_181_9810)">
                      <path
                        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                        fill="white"
                      />
                      <path
                        d="M15.5591 10.9359L15.9594 11.471L16.3598 10.9359C17.0879 9.96261 18.2546 9.33008 19.5558 9.33008C21.764 9.33008 23.5593 11.1288 23.5593 13.358C23.5593 14.2675 23.4143 15.1066 23.1624 15.8851L23.1614 15.8884C22.5573 17.8001 21.3181 19.3442 19.9761 20.4976C18.6318 21.6529 17.2131 22.3913 16.3006 22.7018L16.3006 22.7018L16.2952 22.7037C16.2277 22.7275 16.1059 22.7481 15.9594 22.7481C15.8129 22.7481 15.6912 22.7275 15.6236 22.7037L15.6236 22.7036L15.6183 22.7018C14.7058 22.3913 13.287 21.6529 11.9427 20.4976C10.6006 19.3442 9.36144 17.8001 8.75734 15.8884L8.75735 15.8884L8.7563 15.8851C8.50442 15.1066 8.35938 14.2675 8.35938 13.358C8.35938 11.1289 10.1547 9.33008 12.363 9.33008C13.6642 9.33008 14.8309 9.96261 15.5591 10.9359Z"
                        stroke="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_181_9810">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                ) : (
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    onClick={handleHeartIconClick}
                  >
                    <g clipPath="url(#clip0_315_9939)">
                      <path
                        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                        fill="white"
                      />
                      <path
                        d="M19.5558 8.83008C18.0897 8.83008 16.7775 9.54288 15.9594 10.6364C15.1413 9.54288 13.8291 8.83008 12.363 8.83008C9.87627 8.83008 7.85938 10.8551 7.85938 13.358C7.85938 14.3219 8.01327 15.2129 8.28057 16.0391C9.56037 20.0891 13.5051 22.511 15.4572 23.1752C15.7326 23.2724 16.1862 23.2724 16.4616 23.1752C18.4137 22.511 22.3583 20.0891 23.6381 16.0391C23.9054 15.2129 24.0593 14.3219 24.0593 13.358C24.0593 10.8551 22.0425 8.83008 19.5558 8.83008Z"
                        fill="#FF7700"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_315_9939">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                )}
              </div>
            )}
          </div>
        </div>
        {/* <img src="/images/room.jpg" alt="logo" className="image"/> */}
        <div className="container ">
          <div className="heading-section">
            <h6>{props.title}</h6>
            <button
              className="button_label"
              style={{
                backgroundColor:
                  props.eventLabel === "Upcoming Event"
                    ? "orange"
                    : props.eventLabel === "Urgent"
                    ? "red"
                    : "initial", // Use the default color or any other color you prefer
              }}
            >
              {props.eventLabel}
            </button>
          </div>

          {/* <p className='job-text'>{props.description}</p> */}

          <div className=" location-box">
            <div className="location location-icon">
              <img src="/images/location pin.svg" alt="logo" />

              <div className="location_style">{props.location}</div>
            </div>
          </div>

          <div className=" detail-box">
            <div className="rentAmount">{props.jobAmount}</div>

            <div className="view-btn">
              <div className="heart_count">
                <svg
                  width="25"
                  height="18"
                  viewBox="0 0 25 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M23.3064 7.90968C23.8506 8.62284 23.8506 9.58561 23.3064 10.2976C21.5921 12.5395 17.4793 17.1555 12.6775 17.1555C7.87577 17.1555 3.76293 12.5395 2.04867 10.2976C1.78388 9.95615 1.64014 9.53606 1.64014 9.10365C1.64014 8.67125 1.78388 8.25116 2.04867 7.90968C3.76293 5.66782 7.87577 1.05182 12.6775 1.05182C17.4793 1.05182 21.5921 5.66782 23.3064 7.90968V7.90968Z"
                    stroke="#C9C9C9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M12.6776 12.5544C14.58 12.5544 16.1222 11.0094 16.1222 9.10362C16.1222 7.1978 14.58 5.65283 12.6776 5.65283C10.7752 5.65283 9.23297 7.1978 9.23297 9.10362C9.23297 11.0094 10.7752 12.5544 12.6776 12.5544Z"
                    stroke="#C9C9C9"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
               <span>{props.viewCount}</span>
              </div>
              
            <div className="share_icon"  onClick={(event) => { shareSocialMediaLink(event,props._id,props.shareTitle) }}>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M17.9997 20.4896C17.7312 20.4988 17.4637 20.4539 17.213 20.3575C16.9622 20.2611 16.7335 20.1152 16.5403 19.9285C16.3472 19.7419 16.1936 19.5182 16.0886 19.271C15.9837 19.0237 15.9297 18.7578 15.9297 18.4892C15.9297 18.2206 15.9837 17.9547 16.0886 17.7075C16.1936 17.4602 16.3472 17.2365 16.5403 17.0499C16.7335 16.8632 16.9622 16.7174 17.213 16.621C17.4637 16.5246 17.7312 16.4796 17.9997 16.4888C18.5184 16.5066 19.0099 16.7251 19.3705 17.0983C19.7312 17.4715 19.9328 17.9702 19.9328 18.4892C19.9328 19.0082 19.7312 19.5069 19.3705 19.8801C19.0099 20.2533 18.5184 20.4718 17.9997 20.4896ZM5.9997 14.4896C5.73125 14.4988 5.46369 14.4539 5.21296 14.3575C4.96224 14.2611 4.73349 14.1152 4.54032 13.9285C4.34716 13.7419 4.19355 13.5182 4.08864 13.271C3.98373 13.0237 3.92966 12.7578 3.92966 12.4892C3.92966 12.2206 3.98373 11.9547 4.08864 11.7075C4.19355 11.4602 4.34716 11.2365 4.54032 11.0499C4.73349 10.8632 4.96224 10.7174 5.21296 10.621C5.46369 10.5246 5.73125 10.4796 5.9997 10.4888C6.51839 10.5066 7.0099 10.7251 7.37055 11.0983C7.7312 11.4715 7.93278 11.9702 7.93278 12.4892C7.93278 13.0082 7.7312 13.5069 7.37055 13.8801C7.0099 14.2533 6.51839 14.4718 5.9997 14.4896ZM17.9997 4.49116C18.2682 4.48197 18.5357 4.52691 18.7864 4.6233C19.0372 4.7197 19.2659 4.86557 19.4591 5.05223C19.6522 5.23889 19.8059 5.46252 19.9108 5.7098C20.0157 5.95708 20.0697 6.22294 20.0697 6.49155C20.0697 6.76017 20.0157 7.02603 19.9108 7.27331C19.8059 7.52059 19.6522 7.74422 19.4591 7.93088C19.2659 8.11754 19.0372 8.26341 18.7864 8.35981C18.5357 8.4562 18.2682 8.50114 17.9997 8.49194C17.481 8.47419 16.9895 8.25566 16.6289 7.88245C16.2682 7.50924 16.0666 7.01054 16.0666 6.49155C16.0666 5.97256 16.2682 5.47387 16.6289 5.10066C16.9895 4.72745 17.481 4.50892 17.9997 4.49116ZM17.9997 14.4896C16.7716 14.4896 15.6864 15.0544 14.9528 15.9263L9.94423 13.0365C9.96767 12.856 10.0005 12.6779 10.0005 12.4904C10.0005 12.3779 9.97705 12.2724 9.96767 12.1623L15.0817 9.20913C15.453 9.61313 15.904 9.93582 16.4062 10.1569C16.9084 10.3779 17.451 10.4925 17.9997 10.4935C18.7909 10.4935 19.5643 10.2589 20.2222 9.81942C20.88 9.37991 21.3928 8.75521 21.6957 8.0243C21.9986 7.29339 22.078 6.48909 21.9238 5.71307C21.7696 4.93706 21.3888 4.22419 20.8295 3.66458C20.2702 3.10496 19.5576 2.72374 18.7817 2.56911C18.0057 2.41447 17.2014 2.49336 16.4703 2.79581C15.7392 3.09826 15.1142 3.61069 14.6743 4.26831C14.2344 4.92592 13.9994 5.6992 13.9989 6.49038C13.9989 6.8232 14.0528 7.14195 14.1278 7.45132L9.30439 10.2404C8.91608 9.67032 8.38698 9.21034 7.76845 8.90508C7.14993 8.59982 6.46299 8.45966 5.77431 8.4982C5.08564 8.53673 4.41862 8.75267 3.83802 9.12503C3.25741 9.49739 2.78294 10.0135 2.46066 10.6234C2.13837 11.2332 1.97922 11.916 1.99866 12.6055C2.0181 13.2949 2.21546 13.9677 2.57159 14.5584C2.92771 15.1491 3.43051 15.6377 4.03117 15.9768C4.63183 16.3158 5.30995 16.4938 5.9997 16.4935C7.30048 16.4912 8.44189 15.8607 9.17314 14.8998L14.0763 17.731C13.9194 18.5401 14.0161 19.3778 14.3533 20.1298C14.6906 20.8818 15.2518 21.5112 15.9603 21.9322C16.6688 22.3532 17.49 22.5451 18.3117 22.4816C19.1334 22.4182 19.9154 22.1026 20.5509 21.578C21.1865 21.0533 21.6445 20.3452 21.8623 19.5504C22.0802 18.7555 22.0473 17.9129 21.7681 17.1375C21.4889 16.3621 20.9771 15.6918 20.3026 15.2183C19.6281 14.7448 18.8238 14.4911 17.9997 14.4919V14.4896Z"
                  fill="#6D737A"
                />
              </svg>
            {isShareOpen==true?(<SocialMediaLink url={url} />):null}
            </div>
            </div>


          </div>
          <div className="eye-icon">
            <span>{props.dateType}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
